var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('gl-loading-icon',{staticClass:"gl-mt-5",attrs:{"size":"lg"}}):_c('div',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.readmeHtml),expression:"readmeHtml"}],ref:"readme",staticClass:"md"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }